/** Lower GPU load in local dev; cap retina DPR in production. */
export const CANVAS_DPR =
  process.env.NODE_ENV === "development" ? [1, 1.25] : [1, 1.75];
